// 个性签名长度上限(码点计;与 DB char_length 一致,emoji 算 1)。
// 前端硬截断 + x/50 计数器;后端 profiles CHECK profile_signature_length 同值兜底。
export const SIGNATURE_MAX_LEN = 50

export function signatureLength(value: string): number {
  return [...value].length
}

export function clampSignature(value: string, max: number = SIGNATURE_MAX_LEN): string {
  const cps = [...value]
  return cps.length <= max ? value : cps.slice(0, max).join('')
}
